import React from 'react'
import InstancesCatalogFilter from '../../__filter/_instancesCatalog/catalog__filter_instancesCatalog'
import EditableText from 'blocks.simple/editableText/editableText'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import styles from '../_instancesCatalog/catalog__template_instancesCatalog.jcss'
import { ItemData } from '../../../../core/models/Template'

export default {
    getMethod: 'getCourses',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noCourses'),
    emptyDescription: () => translate('noCoursesDescription'),
    emptyIcon: 'not_allow',
    disableDrag: true,
    addItemButton: () => null,
    settingsPrefixes: 'courses',
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'title', name: translate('byNameAsc') },
    ],
    headerFilters: (p_: { onAddFakeLine: any; selectedItems: { id: number }[]; fakeLine: string }) => (
        <InstancesCatalogFilter
            title={translate('courses')}
            type="course"
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem: { id: number }) => selectedItem.id)
                if (id.length > 0) {
                    api.send('deleteCourse', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
            onAdd={() => {
                p_.onAddFakeLine({ title: '' })
            }}
            {...p_}
        />
    ),
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    getBackendModel: (item: ItemData) => {
        return api.send('getCourse', { id: item.id }, { hideLoader: true })
    },
    tableWrapper: styles.tableWrapper,
    isEqual: (firstItem: ItemData, secondItem: ItemData) => firstItem.id === secondItem.id,
    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('courseCreated', cb, clearList)],
    onUpdateListeners: [(cb: any, clearList: string[]) => api.addObserver('courseUpdated', cb, clearList)],
    onDeleteListeners: [(cb: any, clearList: string[]) => api.addObserver('courseDeleted', cb, clearList)],
    isFolder: () => {},
    fields: () => [{ id: 'title', name: translate('name') }],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        title: (p_: { id: number; title: string }, active: boolean, listProps: { onAddFakeLine: any }) => (
            <EditableText
                id={p_.id}
                text={p_.title}
                onCreate={(title) => api.send('createCourse', { title })}
                onUpdate={(title, cb) => {
                    api.send('updateCourse', { title, id: p_.id }).then(cb)
                }}
                onSaveEmpty={function () {
                    listProps.onAddFakeLine()
                }}
            />
        ),
    },
    hideActiveRowColor: true,
    disableUpdateUserSettings: true,
    onDeleteListItem: (listItem: ItemData) => {
        api.send('deleteCourse', { id: listItem.id })
    },
    fixedColWidth: true,
}
